const Color = {
    PRIMARY_COLOR : "#013F5C",
    SECONDARY_COLOR : "#C1D1D6",
    THIRD_COLOR : '#C5E8B3',
    FORTH_COLOR :'#EFEFE8'
}

export default Color
